module.exports = __webpack_public_path__ + "img/MaintenanceAssembly.fafe03aa.svg";